var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { STATIC_PAGE_V2, ITEM_TYPES } from '../../types/ItemTypes';
import { BLOG_CATEGORY } from '../../item-types/blog-category/pattern-blog-category';
import { getAdapter } from '../../adapters-async';
import { getDefaultItemPayload } from '../../patterns/get-default-item';
import { logInfo } from '../../utils/log-info';
import { getPatternBlob } from '../../../async';
import { _getTags } from '../get-tags';
export function getTags(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.siteLevelSeoData, siteLevelSeoData = _c === void 0 ? {} : _c, _d = _b.pageLevelSeoData, pageLevelSeoData = _d === void 0 ? {} : _d, _e = _b.veloOverrides, veloOverrides = _e === void 0 ? [] : _e, _f = _b.veloItemPayload, veloItemPayload = _f === void 0 ? getDefaultItemPayload() : _f, _g = _b.dynamicPageData, dynamicPageData = _g === void 0 ? [] : _g, _h = _b.tpaSeoEndpointData, tpaSeoEndpointData = _h === void 0 ? [] : _h, _j = _b.tpaOverrides, tpaOverrides = _j === void 0 ? [] : _j, _k = _b.componentsItemPayload, componentsItemPayload = _k === void 0 ? [] : _k, _l = _b.options, options = _l === void 0 ? { logError: function () { } } : _l;
    return __awaiter(this, void 0, void 0, function () {
        var itemType, staticPagePatternBlob, staticPageAdapter, itemTypePatternBlob, _m, adapter;
        var _this = this;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    logInfo(options, { stackTrace: new Error().stack }, 'start');
                    logInfo(options, { blogCategory: BLOG_CATEGORY }, 'getPatternBlob STATIC_PAGE_V2');
                    itemType = veloItemPayload.itemType;
                    return [4 /*yield*/, getPatternBlob(STATIC_PAGE_V2)];
                case 1:
                    staticPagePatternBlob = _o.sent();
                    return [4 /*yield*/, getAdapter(STATIC_PAGE_V2)];
                case 2:
                    staticPageAdapter = _o.sent();
                    if (!(itemType === ITEM_TYPES.BLOG_CATEGORY)) return [3 /*break*/, 3];
                    _m = BLOG_CATEGORY;
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, getPatternBlob(itemType)];
                case 4:
                    _m = _o.sent();
                    _o.label = 5;
                case 5:
                    itemTypePatternBlob = _m;
                    logInfo(options, { itemTypePatternBlob: itemTypePatternBlob, itemType: itemType }, 'getAdapter itemType');
                    return [4 /*yield*/, getAdapter(itemType)];
                case 6:
                    adapter = _o.sent();
                    return [4 /*yield*/, Promise.all(componentsItemPayload.map(function (componentItemPayload) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = {};
                                        return [4 /*yield*/, getPatternBlob(componentItemPayload.itemType)];
                                    case 1:
                                        _a.patternBlob = _b.sent();
                                        return [4 /*yield*/, getAdapter(componentItemPayload.itemType)];
                                    case 2: return [2 /*return*/, __assign.apply(void 0, [(_a.adapter = _b.sent(), _a), componentItemPayload])];
                                }
                            });
                        }); }))];
                case 7:
                    componentsItemPayload = _o.sent();
                    return [2 /*return*/, _getTags({
                            siteLevelSeoData: siteLevelSeoData,
                            pageLevelSeoData: pageLevelSeoData,
                            veloOverrides: veloOverrides,
                            veloItemPayload: veloItemPayload,
                            dynamicPageData: dynamicPageData,
                            tpaSeoEndpointData: tpaSeoEndpointData,
                            tpaOverrides: tpaOverrides,
                            componentsItemPayload: componentsItemPayload,
                            options: options,
                            staticPagePatternBlob: staticPagePatternBlob,
                            staticPageAdapter: staticPageAdapter,
                            itemTypePatternBlob: itemTypePatternBlob,
                            adapter: adapter,
                        })];
            }
        });
    });
}
